(function ($, undefined) {

    // Hamburger
    $('.js_hamburger').on('click', function () {
        $(this).toggleClass('is-active');
        $('body').toggleClass('show_menu');
    });

    // Modal windows
    $('.js_modal_link').on('click', function () {
        var $service_id = $(this).data('service-id');
        var modalID = $(this).attr('modal-target');

        $.arcticmodal('close');
        $('#' + modalID).arcticmodal({
            beforeOpen: function (data, el) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'formOpening',
                    'formType': 'make_an_appointment'
                });

                var selects = el.find('select');
                if (!!$service_id) {
                    console.log($service_id);
                    selects.val($service_id);
                    el.find('select option[value=' + $service_id + ']').attr('selected', 'selected');
                    selects.attr("disabled", true);
                }
                selects.niceSelect('update');

            },
            afterClose: function (data, el) {
                console.log('afterClose');
                var textareas = el.find('textarea');
                if (textareas.length > 0) {
                    textareas.each(function () {
                        $(this).val('').removeClass('error');
                    });
                }

                var selects = el.find('select');
                if (selects.length > 0) {
                    selects.each(function () {
                        var defaultOption = $(this).find('option:first').attr('value');
                        $(this).val(defaultOption);
                        $(this).niceSelect('update');
                        $(this).next().removeClass('selected');
                    });
                }
            }
        });
        return false;
    });

    // Selects
    $('select').niceSelect();
    $('select').on('change', function () {
        $(this).next().addClass('selected');
    });


    // Phone mask
    $('.js_phone_mask').mask("+38 (999) 999-99-99");

    $('.js_fs_slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        appendArrows: $('.js_fs_nav'),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

    $('.js_services_price_list').slick({
        arrows: false,
        dots: false,
        infinite: true,
        adaptiveHeight: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.js_doctors_list_slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<button class="slick-next arrow arrow_prev"><svg fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L1 13l12 12" stroke="#1C0221" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button class="slick-next arrow arrow_next"><svg fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 25l12-12L1 1" stroke="#1C0221" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 601,
                settings: {
                    arrows: false,
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.js_blog_list_slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '<button class="slick-next arrow arrow_prev"><svg fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L1 13l12 12" stroke="#1C0221" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button class="slick-next arrow arrow_next"><svg fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 25l12-12L1 1" stroke="#1C0221" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    arrows: false,
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    speed: 500,
                    fade: true,
                    autoplay: true,
                    autoplaySpeed: 2500,
                    cssEase: 'linear',
                    arrows: false,
                    slidesToShow: 1,
                    draggable: true
                }
            }
        ]
    });

    $('.js_reviews_slider').slick({
        arrows: true,
        dots: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        variableWidth: false,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: '<button class="slick-next arrow arrow_prev"><svg fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L1 13l12 12" stroke="#1C0221" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button class="slick-next arrow arrow_next"><svg fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 25l12-12L1 1" stroke="#1C0221" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    dots: true,
                }
            },
            {
                breakpoint: 601,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                }
            }
        ]
    });

    $('.js_tab_button').on('click', function () {
        $('.js_tab_button.active').removeClass('active');
        $(this).addClass('active');

        var tabID = $(this).data('target');
        $('.js_reviews_slider.active').removeClass('active');
        $('#' + tabID).addClass('active');
    });


    $('.js_checkup_our_slider').slick({
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.js_checkup_other_slider').slick({
        prevArrow: '<button class="slick-next arrow arrow_prev"><svg fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L1 13l12 12" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button class="slick-next arrow arrow_next"><svg fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 25l12-12L1 1" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1134,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                }
            }
        ]
    });

    $('.js_certificate_slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        prevArrow: '<button class="slick-next arrow arrow_prev"><svg fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L1 13l12 12" stroke="#1C0221" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button class="slick-next arrow arrow_next"><svg fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 25l12-12L1 1" stroke="#1C0221" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
            {
                breakpoint: 1110,
                settings: {
                    slidesToShow: 6,
                    arrows: false,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 601,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });

    $('.js_posts_block').slick({
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 601,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });


    $.fn.datepicker.language['ua'] = {
        days: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П\'ятниця', 'Cубота'],
        daysShort: ['Ндл', 'Пнд', 'Втр', 'Срд', 'Чтв', 'Птн', 'Сбт'],
        daysMin: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        months: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липня', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
        monthsShort: ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру'],
        today: 'Сьогодні',
        clear: 'Очистити',
        dateFormat: 'dd.mm.yyyy',
        timeFormat: 'hh:ii',
        firstDay: 1
    };

    $('.js_appointment_date').datepicker({
        language: 'ua',
        range: true,
        toggleSelected: false,
        multipleDatesSeparator: ' - ',
        minDate: new Date()
    });

    function setCaptchaToken(){
        if(window.recaptchaKey){
            grecaptcha.ready(function() {
                grecaptcha.execute(window.recaptchaKey).then(function(token) {
                    document.querySelectorAll('input[name=g-recaptcha-response]').forEach(function (input){
                        input.value = token
                    })
                });
            });
        }
    }

    function createEventData(form) {
        formData =  form.serializeArray().reduce(function(obj, item) {
            obj[item.name] = item.value;
            return obj;
        }, {});

        if (formData.contact_details) {
            let re = /\S+@\S+\.\S+/;
            if (re.test(formData.contact_details)) {
                formData.email = formData.contact_details;
            } else {
                formData.phone = formData.contact_details;
            }

        }

       return {
            'event': formData.event_iLion,
            'phone_number': formData.phone?.replace(/[^\d+]/g, '') || '',
            'email': formData.email || '',
            'address.first_name': formData.name || ''
        };
    }

    $('.js_subscribe_form').on('submit', function (e) {
        e.preventDefault();
        var $email = $(this).find('.email_field');
        var emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if ($email.val() == '' || !emailRegEx.test($email.val())) {
            $email.addClass('error');
        } else {
            let form = $(this).closest('form');
            //ajax headers
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });

            grecaptcha.ready(function() {
                grecaptcha.execute(window.recaptchaKey, {action: 'submit'}).then(function (token) {
                    document.querySelectorAll('input[name=g-recaptcha-response]').forEach(function (input) {
                        input.value = token
                    })

                    let eventData = createEventData(form);

                    //send ajax
                    $.ajax({
                        url: '/api/callback',
                        data: form.serialize(),
                        type: 'POST',
                        dataType: 'json'
                    }).done(function (html) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push(eventData);
                        console.log('callback', eventData);

                        $email.val('');
                        $email.removeClass('error');
                        $('#subscribe-thanks-modal').arcticmodal();
                    });
                })
            });
        }
        return false;
    });

    $('.page_checkup-call-form').on('submit', function (e) {
        e.preventDefault();
        let form = $(this).closest('form');
        let $phone = $(this).find('.js_phone');
        //ajax headers
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        grecaptcha.ready(function() {
            grecaptcha.execute(window.recaptchaKey, {action: 'submit'}).then(function (token) {
                document.querySelectorAll('input[name=g-recaptcha-response]').forEach(function (input) {
                    input.value = token
                })

                let eventData = createEventData(form);

                //send ajax
                $.ajax({
                    url: '/api/callback',
                    data: form.serialize(),
                    type: 'POST',
                    dataType: 'json'
                }).done(function (html) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(eventData);
                    console.log('callaxck 2', eventData);

                    $phone.val('');
                    $phone.removeClass('error');
                    $('#subscribe-thanks-modal').arcticmodal();
                });
                return false;
            })
        });
    });

    $('.js_form_appointment, .js_form_become_partner').on('submit', function (e) {
        e.preventDefault();
        var $allFields = $(this).find('input:not(.submit)');
        var $requiredFields = $(this).find('input:required');
        var $selects = $(this).find('select');
        var $email = $(this).find('input[name="email"]');
        var emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var valid = true;

        $requiredFields.each(function () {
            $(this).removeClass('error');
            if (!$(this).val()) {
                $(this).addClass('error');
                valid = false;
            }
        });

        if ($email.length) {
            $email.removeClass('error');
            if ($email.val() && !emailRegEx.test($email.val())) {
                $email.addClass('error');
                valid = false;
            }
        }
        $('select.form_field').prop('disabled', false);
        let form = $(this).closest('form');
        if (valid) {
            //ajax headers
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });

            grecaptcha.ready(function() {
                grecaptcha.execute(window.recaptchaKey, {action: 'submit'}).then(function(token) {
                    document.querySelectorAll('input[name=g-recaptcha-response]').forEach(function (input){
                        input.value = token
                    })

                     let eventData = createEventData(form);

                    //send ajax
                    $.ajax({
                        url: '/api/orders',
                        data: form.serialize(),
                        type: 'POST',
                        dataType: 'json'
                    }).done(function (html) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push(eventData);
                        console.log('orders', eventData);

                        $selects.each(function () {
                            $(this).find('option[value="default"]').attr('selected', 'selected');
                            $(this).niceSelect('update');
                        });

                        if ($('#make-appointment').closest('.arcticmodal-container').length > 0) {
                            $('#make-appointment').arcticmodal('close');
                        }
                        if ($('#make-appointment-chekapi').closest('.arcticmodal-container').length > 0) {
                            $('#make-appointment-chekapi').arcticmodal('close');
                        }
                        if ($('#make-appointment-uzd').closest('.arcticmodal-container').length > 0) {
                            $('#make-appointment-uzd').arcticmodal('close');
                        }
                        if ($('#js_form_appointment').closest('.arcticmodal-container').length > 0) {
                            $('#js_form_appointment').arcticmodal('close');
                        }
                        if ($('#make-appointment-to-doctor').closest('.arcticmodal-container').length > 0) {
                            $('#make-appointment-to-doctor').arcticmodal('close');
                        }
                        if ($('#make-appointment-all').closest('.arcticmodal-container').length > 0) {
                            $('#make-appointment-all').arcticmodal('close');
                        }
                        if ($('#make-appointment-to-consultation').closest('.arcticmodal-container').length > 0) {
                            $('#make-appointment-to-consultation').arcticmodal('close');
                        }
                        $.arcticmodal('close');

                        //form.trigger('reset');
                        $('#thanks-modal').arcticmodal();

                        $allFields.each(function (item, val) {
                            if ( $(val).attr('name') !== 'appointment' &&
                                 $(val).attr('name') !== 'g-recaptcha-response' &&
                                 $(val).attr('name') !== 'event_iLion') {
                                    $(this).val('');
                                }
                        });
                    });
                });
            });
        }

        return false;
    });

    $('.js_form_resume').on('submit', function (e) {
        e.preventDefault();
        var $allFields = $(this).find('input:not(.submit), textarea');
        var $requiredFields = $(this).find('input:required, textarea:required');
        var $email = $(this).find('input[name="email"]');
        var $fileField = $(this).find('input[type="file"]');
        var emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var valid = true;

        $requiredFields.each(function () {
            $(this).removeClass('error');
            if (!$(this).val()) {
                $(this).addClass('error');
                valid = false;
            }
        });

        if ($email.length) {
            $email.removeClass('error');
            if ($email.val() && !emailRegEx.test($email.val())) {
                $email.addClass('error');
                valid = false;
            }
        }

        if ($fileField.length) {
            $fileField.removeClass('error');
            if ($fileField[0].files.length === 0) {
                $fileField.addClass('error');
                valid = false;
            } else {
                var file = $fileField[0].files[0];
                var maxSize = 10 * 1024 * 1024;
                if (file.size > maxSize) {
                    $fileField.addClass('error');
                    alert('Файл занадто великий. Максимальний розмір: 10MB');
                    valid = false;
                }

                var allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
                if (!allowedTypes.includes(file.type)) {
                    $fileField.addClass('error');
                    alert('Допустимі формати файлів: PDF, DOC, DOCX');
                    valid = false;
                }
            }
        }

        let form = $(this).closest('form');

        if (valid) {
            // AJAX headers
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });

            grecaptcha.ready(function() {
                grecaptcha.execute(window.recaptchaKey, {action: 'submit'}).then(function(token) {
                    document.querySelectorAll('input[name=g-recaptcha-response]').forEach(function (input){
                        input.value = token;
                    });

                    var formData = new FormData(form[0]);

                    $.ajax({
                        url: '/api/resume',
                        data: formData,
                        type: 'POST',
                        dataType: 'json',
                        processData: false,
                        contentType: false,
                        beforeSend: function() {
                            form.find('.submit').prop('disabled', true).val('Надсилання...');
                        }
                    }).done(function (response) {
                        // Google Analytics tracking для резюме
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'resume_submit',
                            'resume_position': form.find('input[name="desired_position"]').val(),
                            'resume_name': form.find('input[name="full_name"]').val()
                        });
                        console.log('resume submitted', response);

                        if ($('#make-appointment-uzd').closest('.arcticmodal-container').length > 0) {
                            $('#make-appointment-uzd').arcticmodal('close');
                        }
                        if ($('#resume-modal').closest('.arcticmodal-container').length > 0) {
                            $('#resume-modal').arcticmodal('close');
                        }
                        $.arcticmodal('close');

                        $('#thanks-modal').arcticmodal();

                        $allFields.each(function (item, val) {
                            if ($(val).attr('name') !== 'g-recaptcha-response') {
                                $(this).val('');
                            }
                        });

                    }).fail(function(xhr, status, error) {
                        console.error('Resume submission failed:', error);
                        alert('Помилка при надсиланні резюме. Спробуйте ще раз.');
                    }).always(function() {
                        form.find('.submit').prop('disabled', false).val('Надіслати резюме');
                    });
                });
            });
        }

        return false;
    });


    /*single_checkup*/
    $('.page_sch-proc-tabs a').click(function (e) {
        e.preventDefault();
        $('.page_sch-proc-tabs a').removeClass('active');
        $(this).addClass('active');
        $('.page_sch-proc-cont').removeClass('active');
        $($(this).attr('href')).addClass('active');
    });
    /*single_checkup*/

    /*single_doctors*/
    $('.page_sdr-info-tabs a').click(function (e) {
        e.preventDefault();
        $('.page_sdr-info-tabs a').removeClass('active');
        $(this).addClass('active');
        $('.page_sdr-info-cont').removeClass('active');
        $($(this).attr('href')).addClass('active');
    });
    /*single_doctors*/

    /*prices*/
    $(document).on('click', '.page_prices-bl-ttl', function (e) {
        e.preventDefault();
        $(this).closest('.page_prices-bl').toggleClass('active');
        $(this).siblings('.page_prices-bl-cont').slideToggle();
    });

    var pricesCont = $('.page_prices .page_prices-cont');
    if (pricesCont.length) {
        var anchor = window.location.hash;
        anchor = anchor.slice(1);
        var service = pricesCont.find('.page_prices-bl-ttl[data-alias=' + anchor + ']');
        service.trigger('click');
    }
    /*prices*/

    /*page_blog*/
    $('.js_drp a').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).siblings('.sub').slideToggle();
    });
    $('.js_mob_click').click(function () {
        if ($(window).width() < 992) {
            $(this).toggleClass('active');
            $(this).siblings('.page_blog-sidebar-list').slideToggle();
        }
    });
    /*page_blog*/

    /*contacts*/
    $('.js_phone').mask('+ 38 (099) 999 – 99 – 99');

    function emailValidation(_this) {
        var emailRegExp = /^((([0-9A-Za-z]{1}[-0-9A-z\.]{1,}[0-9A-Za-z]{1})|([0-9А-Яа-я]{1}[-0-9А-я\.]{1,}[0-9А-Яа-я]{1}))@([-A-Za-z]{1,}\.){1,2}[-A-Za-z]{2,})$/;
        return emailRegExp.test(_this);
    }

    $('.js_form_validation [type="submit"]').click(function (e) {
        e.preventDefault();
        var todo = 0,
            thisForm = $(this).closest('.js_form_validation');
        thisForm.find('[required]').each(function () {
            if ($(this).val() == '') {
                $(this).addClass('error');
                todo++;
            } else {
                if ($(this).attr('type') == 'email') {
                    if (emailValidation($(this).val()) == false) {
                        $(this).addClass('error');
                        todo++;
                    } else
                        $(this).removeClass('error');
                } else {
                    $(this).removeClass('error');
                }
            }
        });
        if (todo == 0)
            if (thisForm.hasClass('has_thanks_modal')) {
                $('#thanks-modal').arcticmodal();
                thisForm.find('[required]').each(function () {
                    $(this).val('');
                });

            } else {
                if (thisForm.hasClass('page_checkup-call-form')) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'formSubmission',
                        'formType': 'make_an_appointment_short'
                    });
                }
                thisForm.submit();
            }

    });
    $('.js_contact_form').submit(function (e) {
        e.preventDefault();
        let form = $(this).closest('form');
        //ajax headers
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        grecaptcha.ready(function() {
            grecaptcha.execute(window.recaptchaKey, {action: 'submit'}).then(function (token) {
                document.querySelectorAll('input[name=g-recaptcha-response]').forEach(function (input) {
                    input.value = token
                })

                let eventData = createEventData(form);

                //send ajax
                $.ajax({
                    url: '/api/contacts',
                    data: form.serialize(),
                    type: 'POST',
                    dataType: 'json'
                }).done(function (html) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(eventData);
                    console.log('contacts', eventData);

                    var modalID = 'thanks-modal';
                    $.arcticmodal('close');
                    $('#' + modalID).arcticmodal();
                    form.trigger('reset');
                });
            })
        });
    });
    /*contacts*/

    /*about*/
    $('.js_modal_sert').on('click', function (e) {
        e.preventDefault();
        var modalHref = $(this).attr('href');
        $.arcticmodal('close');
        $('#gal-modal').arcticmodal({
            beforeOpen: function (data, el) {
                $('.js_galModal_img').attr('src', modalHref);
            }
        });
    });
    $('.js_about_slider').slick({
        nextArrow: '<svg class="slick-next slick-arrow" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg" style=""><path d="M18 12l12 12-12 12" stroke="#2B2D42" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
        prevArrow: '<svg class="slick-prev slick-arrow" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg" style=""><path d="M30 36L18 24l12-12" stroke="#2B2D42" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: false,
        asNavFor: '.js_about_thumbs',
        speed: 1000,
        fade: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    draggable: true,
                    arrows: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    draggable: true,
                    fade: false,
                    arrows: false,
                    dots: true
                }
            }
        ]
    });
    $('.js_about_thumbs').slick({
        nextArrow: '<svg class="slick-next slick-arrow" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg" style=""><path d="M18 12l12 12-12 12" stroke="#2B2D42" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
        prevArrow: '<svg class="slick-prev slick-arrow" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg" style=""><path d="M30 36L18 24l12-12" stroke="#2B2D42" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        draggable: false,
        asNavFor: '.js_about_slider',
        focusOnSelect: true,
        speed: 1000,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4
                }
            }
        ]
    });
    /*about*/
})(jQuery);
$("body").on('click', ".js-blog_read_more", function () {

    var button = $(this);

    $.ajax({
        url: location.href,
        type: 'get',
        data: {page: button.data('page')},
        dataType: 'json'
    })
        .done(function (html) {
            if (html.status == 'success') {
                $('.page_blog-row').append(html.content);
                button.data('page', html.page);
                if (!html.needButton) {
                    button.remove();
                }
            }
        })
        .fail(function (html) {
            console.log(html);
        });

    return false;
});

$('.js_niceSel-doctors').on('change', function () {
    $(this).closest('form').submit();
});

$("body").on('click', "#load-more", function () {

    var button = $(this);

    $.ajax({
        url: location.href,
        type: 'get',
        data: {page: button.data('page')},
        dataType: 'json'
    })
        .done(function (html) {
            if (html.status == 'success') {
                $('.page_doctors-row').append(html.doctors);
                button.data('page', html.page);
                if (!html.needButton) {
                    button.remove();
                }
            }
        })
        .fail(function (html) {
            console.log(html);
        });

    return false;
});
if (jQuery('.page_sdr-info-tabs').length > 0) {
    jQuery('.page_sdr-info-tabs a:first-child').addClass('active');
    jQuery('.page_sdr-info-cont:first').addClass('active');
}
//page search modal form_appointment
if ($('.page_sr-bl-btn').length > 0) {
    $('.page_sr-bl-btn').on('click', function () {
        var val = $(this).data('appointment-value');
        console.log(val);
        $(".form_appointment input[name='appointment']").val(val);
    });
}

if ($('.js_modal_link').length > 0) {
    $('.js_modal_link').on('click', function () {
        var val = $(this).data('appointment-value');
        console.log(val);
        $(".form_appointment input[name='appointment']").val(val);
    });
}

$('.goto').on('click', function () {
    let id = $(this).attr('data-id');
    var hiddenElement = document.getElementById(id);
    hiddenElement.scrollIntoView({block: "end", behavior: "smooth"});
    $('.js_hamburger').click();
});

let lastScrollTop = 0;
const header = document.querySelector('header');
window.addEventListener('scroll', () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let startScroll = 60;

    if (scrollTop > lastScrollTop && scrollTop > startScroll) {
        header.classList.add('hidden');
    } else if (scrollTop < startScroll) {
        header.classList.remove('hidden');
    }

    lastScrollTop = scrollTop;
});
